export enum FIREBASE_COLLECTIONS {
  ERROR_LOG = 'error_log',
  ORDERS = 'orders',
  PREFERENCES = 'preferences',
  ORDER_AND_SUBS_UPDATES = 'orderAndSubsUpdates',
}

export enum LOCALSTORAGE_KEYS {
  CART = 'cart',
  ORDER = 'order',
  SESSION = 'session',
  ANONYMOUS_ADDRESS = 'anonymousAddress',
  SELECTED_CATEGORY = 'selectedCategory',
  NEW_ACCOUNT = 'newAccount',
  GOOGLEPLACERESULT = 'googlePlaceObject',
  MARKETING_REFERRAL = 'marketingReferral',
  FIRST_LOGIN = 'firstLogin',
  SIGNUP_CUSTOM_BOX = 'signupCustomBox',
  SELECTED_DELIVERY_PREFERENCE = 'selectedDeliveryPreference',
  SELECTED_PICKUP_OPTION = 'selectedPickUpOption',
  ROUTE_TO_NAVIGATE_AFTER_LOGIN = 'routeToNavigateAfterLogin',
  FROM_LOGIN = 'fromLogin',
  PERMISSIONS = 'permissions',
  SIGNUP_SELECTED_MEMBERSHIP = 'signupSelectedDelivery',
  NO_PASSWORD_USER_EMAIL = 'noPasswordUserEmail',
  MAINTENANCE_MODE = 'maintenanceMode',
  MAINTENANCE_SCHEDULED = 'maintenanceScheduled',
  MAINTENANCE_TITLE = 'maintenanceTitle',
  MAINTENANCE_MESSAGE = 'maintenanceMessage',
  WELCOME_CUSTOM_BOX = 'welcomeCustomBox',
  CATEGORY_TO_SELECT_ON_SHOP = 'categoryToSelectOnShop',
  LINK_TO_GO_IN_HOME = 'linkToGoInHome',
  PRELOADED_EMAIL = 'preloadedEmail',
  SHOULD_SHOW_CART_PREVIEW = 'shouldShowCartPreview',
  PREVENT_SHOWING_NEW_WEBSITE_WELCOME = 'preventShowingNewWebsiteWelcome',
  PROMOTION_INFO = 'promotionInfo',
  SIGNUP_FUNNEL_STEPS_COMPLETED = 'signupFunnelStepsCompleted',
  FIRST_TOUCH_ATTRIBUTION = 'firstTouchAttribution',
  /** Explorer flow (DEV-11262). The product the visitor was trying to add when
   *  the check-address modal interrupted them, so the card can flip straight
   *  back to add-mode once the explorer account exists. Consumed and removed. */
  EXPLORER_PRODUCT_ADDED = 'explorerProductAdded',
  /** Orders returned by `POST /explorer/activate`, used to render the summary
   *  on the welcome screen instead of a bare confirmation. */
  ORDERS_SUMMARY = 'ordersSummary',
  /** Signup email verification. Written and immediately erased as a pulse: the
   *  `storage` event it fires is how the waiting tab learns the link was opened
   *  in another one, on browsers without BroadcastChannel. */
  SIGNUP_EMAIL_VERIFIED = 'signupEmailVerified'
}
